import React from 'react'
import Helmet from 'react-helmet'
var ScrollMagic
if (typeof window === 'object') {
	ScrollMagic = require('scrollmagic')
}

import CustomHelmet from '../components/CustomHelmet'
import Hero from '../components/Destination/Hero'
import BannerImage from '../components/Destination/BannerImage'
import Regions from '../components/Destination/Regions'
import Experience from '../components/Destination/Experience'
import Apprenticeship from '../components/Destination/Apprenticeship'
import CountryDetails from '../components/Destination/CountryDetails'
import Culture from '../components/Destination/Culture'
import Quote from '../components/Destination/Quote'

// if(typeof window == 'object') {
// 	require('imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js')
// }

class DestinationDetail extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			showCountryDetails: true,
			controller: null
		}
	}

	componentDidMount() {
		let Parallax = {
			init(el, displace, offset) {
				this.animateItem(el, displace, offset)
			},
			setPosition() {
				if (window.pageYOffset !== undefined) {
					return window.pageYOffset
				} else {
					return (
						document.documentElement ||
						document.body.parentNode ||
						document.body
					).scrollTop
				}
			},
			animateItem(el, displace, offset) {
				if (typeof window.orientation !== 'undefined') {
					return
				}
				let scrollPosition = this.setPosition()
				el.style.transform =
					'translate3d(0px, ' + scrollPosition / displace + 'px, 0px)'
				el.style.marginTop = offset
			}
		}

		this.controller = new ScrollMagic.Controller()
		this.setState({
			controller: this.controller
		})
		setTimeout(() => this.navSceneInit(), 450)

		let hideCountryDetails = (elOne, elTwo, elThree, elFour, elFive) => {
			if (
				typeof window.orientation !== 'undefined' ||
				window.innerWidth < 1096
			) {
				return
			}

			let distanceTopOne = elOne.getBoundingClientRect().top,
				distanceBottomOne = elOne.getBoundingClientRect().bottom,
				distanceTopTwo = elTwo.getBoundingClientRect().top,
				distanceBottomTwo = elTwo.getBoundingClientRect().bottom,
				distanceTopThree = elThree.getBoundingClientRect().top,
				distanceBottomThree = elThree.getBoundingClientRect().bottom,
				distanceTopFour = elFour.getBoundingClientRect().top,
				distanceBottomFour = elFour.getBoundingClientRect().bottom,
				distanceTopFive = elFive.getBoundingClientRect().top

			if (
				(distanceTopOne < 750 && distanceBottomOne > 240) ||
				(distanceTopTwo < 750 && distanceBottomTwo > 240) ||
				(distanceTopThree < 750 && distanceBottomThree > 240) ||
				(distanceTopFour < 750 && distanceBottomFour > 240) ||
				distanceTopFive < 750
			) {
				this.setState({
					showCountryDetails: false
				})
			} else {
				this.setState({
					showCountryDetails: true
				})
			}
		}

		const ScrollReveal = require('scrollreveal')

		let ParaImages = document.querySelectorAll('.para-item'),
			itemOne = document.querySelector('#bannerOne'),
			itemTwo = document.querySelector('#experienceSection'),
			itemThree = document.querySelector('#bannerTwo'),
			itemFour = document.querySelector('#apprenticeshipSection'),
			itemFive = document.querySelector('#bannerThree')

		let handleScrolling = () => {
			ParaImages[0] && Parallax.init(ParaImages[0], -8.2, '180px')
			ParaImages[1] && Parallax.init(ParaImages[1], -8.2, '350px')
			ParaImages[2] && Parallax.init(ParaImages[2], -8.2, '480px')

			hideCountryDetails(itemOne, itemTwo, itemThree, itemFour, itemFive)
		}

		window.addEventListener('scroll', handleScrolling)

		window.setTimeout(() => {
			window.sr = ScrollReveal()
			sr.reveal('.apprenticeships-card', { duration: 600, delay: 200 }, 80)
			sr.reveal('.profile-image', { duration: 800 })
			sr.reveal('.quote-text', { duration: 1000, delay: 100 })
		}, 200)
	}
	componentWillUnmount() {
		this.state.controller ? this.state.controller.destroy(true) : null
		this.controller ? this.controller.destroy(true) : null
	}
	navSceneInit() {
		var triggerHook =
			window.innerWidth > 1200 ? 0.3 - 207 / window.innerHeight : null

		if (triggerHook != null) {
			this.navScene = new ScrollMagic.Scene({
				triggerElement: this.pageNav,
				triggerHook
			})
				.setPin(this.pageNav.children[0])
				.addTo(this.controller)
			// .addIndicators()
		}
	}

	render() {
		const {
			data: { page }
		} = this.props
		const seoKeywords = page.seoData.keywords
			? page.seoData.keywords.toString()
			: ``
		//console.log('THE DATA ===> ', page);
		// console.log('THE IMAGES ===> ', page.bannerImage, page.secondBannerImage, page.thirdBannerImage);
		return (
			<div className="dest">
				<CustomHelmet data={page.seoData} />
				<CountryDetails
					locationMap={page.locationMap}
					language={page.language}
					timeZone={page.timeZone}
					currency={page.currency.currency}
					apprenticeships={page.apprenticeships}
					showCountryDetails={this.state.showCountryDetails}
					callbackRef={el => (this.pageNav = el)}
				/>
				<Hero
					title={page.destinationName}
					featuredImage={page.featuredImage}
					description={page.destinationDescription.destinationDescription}
				/>
				<BannerImage image={page.bannerImage} identifier={'bannerOne'} />
				<Regions cards={page.regions} />

				<Experience
					title={page.experienceTitleOne}
					featuredImage={page.experienceImageOne}
					text={page.experienceTextOne.experienceTextOne}
					identifier={'experienceSection'}
				/>

				<Apprenticeship
					title={page.apprenticeshipTitle}
					intro={page.apprenticeshipIntro}
					cards={page.apprenticeshipCards}
					identifier={'apprenticeshipSection'}
				/>
				<BannerImage image={page.secondBannerImage} identifier={'bannerTwo'} />
				<Culture
					title={page.experienceTitleTwo}
					cards={page.experienceItemsTwo}
				/>
				<BannerImage image={page.thirdBannerImage} identifier={'bannerThree'} />
				<Quote
					image={page.quoteImage}
					title={page.quoteTitle}
					text={page.quoteText.quoteText}
					link={page.quoteLink}
				/>
			</div>
		)
	}
}

export default DestinationDetail

export const query = graphql`
	query DestinationTemplateQuery($id: String!) {
		page: contentfulDestination(id: { eq: $id }) {
			id
			slug
			destinationName
			destinationDescription {
				destinationDescription
			}
			featuredImage {
				sizes(quality: 100, maxWidth: 1800) {
					...GatsbyContentfulSizes_withWebp
				}
				file {
					url
					contentType
					fileName
				}
				title
			}
			locationMap {
				file {
					url
					contentType
					fileName
				}
				title
			}
			language
			timeZone
			currency {
				currency
			}
			apprenticeships
			bannerImage {
				sizes(quality: 100, maxWidth: 1800) {
					...GatsbyContentfulSizes_withWebp
				}
				file {
					url
					contentType
					fileName
				}
				title
			}
			regions {
				title
				text {
					text
				}
				featuredImage {
					file {
						url
						contentType
						fileName
					}
					title
				}
				locationImage {
					file {
						url
						contentType
						fileName
					}
					title
				}
				regionDetails {
					title
					text {
						text
					}
				}
			}
			experienceTitleOne
			experienceTextOne {
				experienceTextOne
			}
			experienceImageOne {
				file {
					url
					contentType
					fileName
				}
				title
			}
			apprenticeshipTitle
			apprenticeshipIntro {
				apprenticeshipIntro
			}
			apprenticeshipCards {
				title
				text {
					text
				}
				link
			}
			secondBannerImage {
				sizes(quality: 100, maxWidth: 1800) {
					...GatsbyContentfulSizes_withWebp
				}
				file {
					url
					contentType
					fileName
				}
				title
			}
			experienceTitleTwo
			experienceItemsTwo {
				title
				text {
					text
				}
				mediaAsset {
					file {
						url
						contentType
						fileName
					}
					title
				}
			}
			thirdBannerImage {
				sizes(quality: 100, maxWidth: 1800) {
					...GatsbyContentfulSizes_withWebp
				}
				file {
					url
					contentType
					fileName
				}
				title
			}
			quoteImage {
				file {
					url
					contentType
					fileName
				}
				title
			}
			quoteTitle
			quoteText {
				quoteText
			}
			quoteLink {
				text
				link
			}
			seoData {
				pageTitle
				pageDescription {
					pageDescription
				}
				keywords
				openGraphTitle
				openGraphDescription {
					openGraphDescription
				}
				openGraphImage {
					file {
						url
					}
				}
			}
		}
	}
`



// WEBPACK FOOTER //
// ./src/templates/destination.js